import Config from '@config';
import { CACHE_EXPIRATION_TIME } from '@gasbi/shared/common/features/constants';
import { createApi } from '@reduxjs/toolkit/query/react';

import '@/features/myBranch/__mocks__';
import axiosBaseQuery from '@/utils/axiosBaseQuery';

import { BranchInfo, Employee, Subdivision } from './types';

export const myBranchApi = createApi({
  reducerPath: 'myBranchApi',
  baseQuery: axiosBaseQuery({
    baseUrl: Config.VITE_API_URL + '/my-branch',
  }),
  tagTypes: ['MyBranch', 'Subdivisions', 'Employees'],
  keepUnusedDataFor: CACHE_EXPIRATION_TIME,
  endpoints: builder => ({
    getMyBranch: builder.query<BranchInfo, void>({
      query: () => ({ url: '' }),
      providesTags: ['MyBranch'],
    }),
    getSubdivisions: builder.query<Subdivision[], void>({
      query: () => ({ url: '/subdivisions' }),
      providesTags: ['Subdivisions'],
    }),
    getEmployees: builder.query<Employee[], void>({
      query: () => ({ url: '/employees' }),
      providesTags: ['Employees'],
    }),
  }),
});

export const {
  useGetMyBranchQuery,
  useGetSubdivisionsQuery,
  useGetEmployeesQuery,
} = myBranchApi;
